import { styled as t } from "styled-components";
import { TextSkeleton as i } from "../TextSkeleton/index.js";
const r = t.i`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  aspect-ratio: 1 / 1;
`, s = t.svg`
  transform: scale(0.7);
  width: 1em !important;
  aspect-ratio: 1/1;
`;
t(i)`
  border-radius: 25%;
  width: 1em;
  height: 1em;
  display: inline-block;

  font-size: ${({ size: e }) => e ? `${e}px` : "24px"};
`;
export {
  r as IconContainer,
  s as Svg
};
